<template>
  <div class="d-flex mt-4">
    <MediaContainer
      readOnly
      onlyThumbnails
      smallThumbnails
      slot="left"
      :images="response"
    />
  </div>
</template>

<script>
import MediaContainer from '@/components/MediaContainer/MediaContainer.vue'

export default {
  name: 'Response',

  components: {
    MediaContainer,
  },

  props: {
    response: [Array],
  },
}
</script>
